// Mapeamento centralizado dos tipos de categoria
// Deve ser mantido sincronizado com o enum CategoryType.java do backend
export const CATEGORY_TYPES = {
  HOUSING: { label: 'Habitação', isExpense: true },
  TRANSPORT: { label: 'Transporte', isExpense: true },
  FOOD: { label: 'Alimentação', isExpense: true },
  HEALTH: { label: 'Saúde', isExpense: true },
  PROFESSIONAL: { label: 'Profissional', isExpense: true },
  MISC: { label: 'Diversos', isExpense: true },
  CHILDREN: { label: 'Filhos', isExpense: true },
  EDUCATION: { label: 'Educação', isExpense: true },
  BANKING: { label: 'Bancário', isExpense: true },
  INVESTMENT_IMMEDIATE: { label: 'Investimento Imediato', isExpense: true },
  INVESTMENT_FUTURE: { label: 'Investimento Futuro', isExpense: true },
  OTHER_INVESTMENTS: { label: 'Outros Investimentos', isExpense: true },
  INCOMES: { label: 'Receitas', isExpense: false }
};

// Função para obter o label de um tipo
export const getCategoryTypeLabel = (type) => {
  return CATEGORY_TYPES[type]?.label || type;
};

// Função para verificar se é tipo de despesa
export const isExpenseType = (type) => {
  return CATEGORY_TYPES[type]?.isExpense !== false;
};

// Array para uso em selects/dropdowns
export const getCategoryTypeOptions = () => {
  return Object.entries(CATEGORY_TYPES).map(([value, config]) => ({
    value,
    label: config.label
  }));
}; 